import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCardJcb = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#pet__clip0_6742_14451)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#pet__paint0_linear_6742_14451)",
				d: "M14.4463 11.231H15.7164H15.8978C16.0793 11.231 16.2607 11.0439 16.2607 10.6698C16.2607 10.2957 16.0793 10.1086 15.8978 10.1086H15.7164H14.4463V11.231Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#pet__paint1_linear_6742_14451)",
				d: "M15.5345 3C14.2644 3 13.3572 3.93534 13.3572 5.24482V7.6767H16.4418H16.6232C17.349 7.6767 17.8933 8.05084 17.8933 8.79911C17.8933 9.36032 17.5304 9.73445 16.8046 9.92152C17.5304 9.92152 18.0748 10.2957 18.0748 11.0439C18.0748 11.7922 17.5304 12.1663 16.6232 12.1663H13.1758V17H16.6232C17.8933 17 18.8005 16.0647 18.8005 14.7552V3H15.5345Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#pet__paint2_linear_6742_14451)",
				d: "M16.2599 8.79912C16.2599 8.42498 16.0785 8.23792 15.8971 8.23792C15.8971 8.23792 15.8971 8.23792 15.7156 8.23792H14.627V9.36032H15.7156H15.8971C15.8971 9.36032 16.2599 9.17326 16.2599 8.79912Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#pet__paint3_linear_6742_14451)",
				d: "M3.37752 3C2.10741 3 1.2002 3.93534 1.2002 5.24482V10.8569C1.74453 11.231 2.4703 11.4181 3.19607 11.4181C3.92185 11.4181 4.46618 10.8569 4.46618 10.2957V7.6767H6.28061V10.2957C6.28061 11.4181 5.73628 12.1663 3.55896 12.1663C2.28886 12.1663 1.2002 11.7922 1.2002 11.7922V17H4.46618C5.73628 17 6.6435 16.0647 6.6435 14.7552V3H3.37752Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#pet__paint4_linear_6742_14451)",
				d: "M9.45564 3C8.18554 3 7.27832 3.93534 7.27832 5.24482V8.23791C7.82265 7.6767 8.72987 7.48963 10.3629 7.48963C11.2701 7.48963 12.1773 7.6767 12.1773 7.6767V8.61204C11.8144 8.42498 11.2701 8.23791 10.5443 8.05084C9.2742 8.05084 8.54842 8.61204 8.54842 9.54739C8.54842 10.6698 9.2742 11.231 10.5443 11.0439C11.2701 11.0439 11.8144 10.8569 12.1773 10.4827V11.4181C12.1773 11.4181 11.2701 11.6051 10.3629 11.6051C8.72987 11.6051 7.82265 11.4181 7.27832 10.8569V17H10.5443C11.8144 17 12.7216 16.0647 12.7216 14.7552V3H9.45564Z"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "pet__paint0_linear_6742_14451",
			x1: 13.4269,
			x2: 31.5839,
			y1: 10.7265,
			y2: 10.7265,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#007940" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .2285,
					stopColor: "#00873F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .7433,
					stopColor: "#40A737"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#5CB531"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "pet__paint1_linear_6742_14451",
			x1: 13.4265,
			x2: 22.6169,
			y1: 9.97801,
			y2: 9.97801,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#00873F" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .7433,
					stopColor: "#40A737"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#5CB531"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "pet__paint2_linear_6742_14451",
			x1: 13.4261,
			x2: 31.5831,
			y1: 8.8552,
			y2: 8.8552,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#007940" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .2285,
					stopColor: "#00873F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .7433,
					stopColor: "#40A737"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#5CB531"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "pet__paint3_linear_6742_14451",
			x1: 1.17561,
			x2: 8.17298,
			y1: 9.88444,
			y2: 9.88444,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#004E94" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .8261,
					stopColor: "#0066B1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#006FBC"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "pet__paint4_linear_6742_14451",
			x1: 7.1808,
			x2: 13.0626,
			y1: 9.60373,
			y2: 9.60373,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#BE1833" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .8585,
					stopColor: "#DC0436"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E60039"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "pet__clip0_6742_14451",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		})
	] })]
});
const ForwardRef = forwardRef(SvgIconCardJcb);
export default ForwardRef;
